<template>
  <div class="grade">
    <button
      class="button"
      :class="{selected: activated && selected, 'not-selected': activated && !selected}"
      :style="style"
      @click="select"
    >{{text}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'GradeButton',
  props: ['grade', 'count', 'activated', 'selected'],
  data() {
    return {
      grades: {
        na: {
          text: 'Not Applicable',
          color: '#D4D6E4'
        },
        1: {
          text: 'Outstanding',
          color: '#00B9C1'
        },
        2: {
          text: 'Good',
          color: '#49E5A6'
        },
        3: {
          text: 'Requires Improvement',
          color: '#FFCB4B'
        },
        4: {
          text: 'Inadequate',
          color: '#E76D93'
        },
        true: {
          text: 'Clearly Included',
          color: '#00B9C1'
        },
        false: {
          text: 'Not Included',
          color: '#E76D93'
        }
      }
    }
  },
  computed: {
    style() {
      return {
        background: this.grades[this.grade].color
      }
    },
    text() {
      return this.grades[this.grade].text
    }
  },
  methods: {
    select() {
      this.$emit('grade-selected', this.grade)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
.button {
  position: relative;
  width: 100%;
  height: 2.2rem;
  border-radius: 99px;
  border: unset;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  transition: box-shadow 150ms ease-in-out;
  font-size: 0.9rem;
  line-height: 1.25rem;
  color: '#151B2F';
  font-weight: 600;
  font-family: ArboriaBook;
  transition: all 150ms ease-in-out;
}

.button:focus,
.button:active {
  outline: unset;
}
.button:active {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3) inset;
}

.button.selected {
  opacity: 1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.button.not-selected {
  opacity: 0.3;
}
</style>
